import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import { EnglishLevelParams } from './EnglishLevel.type';

let listTypesRequest: any = null;

const EnglishLevelService = {
  getList: ({ ids }: EnglishLevelParams) => {
    listTypesRequest && listTypesRequest.cancel();
    listTypesRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`people/english-levels`), {
      cancelToken: listTypesRequest.token,
      params: {
        filter: {
          ids,
        },
      },
    });
  },
};

export default EnglishLevelService;
